import React, { useEffect, useState } from "react";
import { ContentResponse } from "../../services/api.response.service";
import { CalculateUserReadPoints } from "../../utils/extraFunctions";

interface CourseContentReadProps {
  content: ContentResponse;
}

function CourseContentRead({ content }: CourseContentReadProps) {
  const [giveUserPoint, setGiveUserPoint] = useState<boolean>(false);
  const [isUserMouseOnCard, setIsUserMouseOnCard] = useState<boolean>(false);
  const [isUserScrollingCard, setIsUserScrollingCard] = useState<boolean>(false);

  useEffect(() => {
    setGiveUserPoint(false);
  }, [content]);

  useEffect(() => {
    CalculateUserReadPoints({
      setGiveUserPoint,
      setIsUserMouseOnCard,
      setIsUserScrollingCard,
      isUserMouseOnCard,
      isUserScrollingCard,
      giveUserPoint,
    });
  });

  return (
    <div
      className="read-pane read-content-flat"
      style={{
        maxWidth: "100%",
        overflowY: "auto",
        height: "76em",
        padding: "0 0 2rem",
      }}
    >
      <div
        className="read-content-body"
        dangerouslySetInnerHTML={{
          __html: content.text_content,
        }}
      />
    </div>
  );
}

export default CourseContentRead;
